import {DOCUMENT, Inject, Injectable, OnDestroy} from '@angular/core';
import {LanguageService, OCC_USER_ID_ANONYMOUS} from '@spartacus/core';
import {Subscription} from 'rxjs';

import {AUTH_SESSION_KEY, INTERNAL_AUTH_URL_PARAM} from '../../service/auth/aimo-auth.service';
import {AimoUserService} from "../../service/user/aimo-user.service";

@Injectable({
    providedIn: 'root',
})
export class AimoRoutingService implements OnDestroy {
    subscription: Subscription = new Subscription();
    lang: string;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        protected languageService: LanguageService,
        protected userService: AimoUserService
    ) {
        this.subscription.add(
            this.languageService.getActive().subscribe((lang) => {
                this.lang = lang;
            }),
        );
    }

    isPikatukku(): boolean {
        return this.document.location.host?.indexOf('pikatukku') >= 0;
    }

    getPikatukkuUrl(ssoParam: string, mobileApp: boolean): string {
        return this.document.location.origin.replace('toimitustukku', 'pikatukku') + '/' + this.lang + (mobileApp ? '/mobileApp/' : '') + ssoParam;
    }

    getToimitustukkuUrl(ssoParam: string, mobileApp: boolean): string {
        return this.document.location.origin.replace('pikatukku', 'toimitustukku') + '/' + this.lang + (mobileApp ? '/mobileApp/' : '') + ssoParam;
    }

    // this will break the cdc login
    getAuthStringInternal(): string {
        const authString = this.document.defaultView.localStorage?.getItem(AUTH_SESSION_KEY);
        const authJSON = JSON.parse(authString);
        if (authJSON === null || authJSON === undefined || authJSON?.userId === OCC_USER_ID_ANONYMOUS) {
            return '';
        }
        return INTERNAL_AUTH_URL_PARAM + '=' + encodeURI(btoa(authString));
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
